// Pure predicates for VenueShell's width behaviour.  Extracted so the
// decision can be unit-tested from the root vitest (routing decisions live
// in web/src/lib/router-decisions.ts by the same pattern, see CLAUDE.md).

/**
 * True when the given route should get a WIDE desktop container (roughly
 * `max-w-6xl` at lg+) instead of the default app-width column.
 *
 * Today: event detail pages (`/events/<id>`).  Studio Two Point flagged
 * 2026-09-23 that these looked like a mobile view stretched vertically
 * on a laptop, wasting horizontal space.  The list `/events` stays
 * app-width because it's a scannable list of cards, not a rich page.
 *
 * Keep this list SMALL and case-by-case.  The default column width is
 * intentional for the native-app-mimicking pages; only pages that carry
 * genuinely wide content (2-col layouts with a sticky sidebar) should
 * opt in.
 */
export function shouldExpandOnDesktop(pathname: string): boolean {
  // /events/<something-non-empty> — the detail page, not the list.
  // Match /events/xyz and /events/xyz/anything, NOT /events or /events/ alone.
  return /^\/events\/[^/]+/.test(pathname);
}
